import Load from './Load';
import { connect } from 'react-redux';
import {
  listRequestedDocuments,
  resetAndStartAppNew,
  setUsersData,
  createDemoRequest,
  loadCrossDeviceRequest,
  listRequestedDocumentsTemplate,
  receiveListRequestedDocumentsTemplate,
  requestListTemplateDocuments,
  receiveStandaloneDraft
} from '../redux/actions/rootAction';
import { REQUEST_TYPE } from '../lib/utils';

const mapStateToProps = (state, ownProps) => {
  return {
    previewMode: ownProps.requestInfo?.requestType === REQUEST_TYPE.PREVIEW,
    embedMode: state.embedMode,
    isFetching: state.isFetching,
    recipientRequestId: state.recipientRequestId,
    previewDocumentId: state.previewDocumentId,
    requestInfo: ownProps.requestInfo,
    startedFromQR: ownProps.startedFromQR,
    requestedDocuments: state.requestedDocuments,
    errorMessage: state.errorMessage,
    infoMessage: state.infoMessage,
    closed: state.closed,
    analyticsDisabled: state.analyticsDisabled,
    usersData: state.usersData,
    submitted: state.submitted,
    caseName: state.caseName,
    companyName: state.companyName,
    scanStarted: Boolean(state.scanStarted),
    scanEnded: state.scanEnded,
    templateMode: state.templateMode,
    brandingDetails: state.brandingDetails,
    userFields: state.userFields,
    authOnStartRequired: state.authOnStartRequired,
    crossDeviceRequest: state.crossDeviceRequest,
    appKey: state.appKey
  };
};

const mapDispatchToProps = dispatch => ({
  getCrossDeviceRequest: crossDeviceId =>
    dispatch(loadCrossDeviceRequest(crossDeviceId)),
  listRequestedDocuments: (recipientRequestId, securePin) =>
    dispatch(listRequestedDocuments(recipientRequestId, securePin)),
  listRequestedDocumentsTemplate: recipientRequestId =>
    dispatch(listRequestedDocumentsTemplate(recipientRequestId)),
  requestListTemplateDocuments: () => dispatch(requestListTemplateDocuments()),
  receiveListRequestedDocumentsTemplate: (response, templateId) =>
    dispatch(receiveListRequestedDocumentsTemplate(response, templateId)),
  createDemoRequest: recipientRequestId =>
    dispatch(createDemoRequest(recipientRequestId)),
  resetAndStartAppNew: newRequestStartInfo =>
    dispatch(resetAndStartAppNew(newRequestStartInfo)),
  setUsersData: data => dispatch(setUsersData(data)),
  receiveStandaloneDraft: draftState =>
    dispatch(receiveStandaloneDraft(draftState))
});

export default connect(mapStateToProps, mapDispatchToProps)(Load);
